// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".job_board_container{background:linear-gradient(90deg,#5e60ce 66.28%,#48bfe3)}", ""]);
// Exports
module.exports = exports;
